export const MAX_TEMPLATE_TAG_LENGTH = 50

/** Stable order for draft vs server comparison (matches server-style dedupe). */
export function normalizeTagsForCompare(tags: string[] | undefined): string[] {
  const seen = new Map<string, string>()
  for (const t of tags ?? []) {
    const s = t.trim()
    if (!s) continue
    const key = s.toLowerCase()
    if (!seen.has(key)) seen.set(key, s)
  }
  return [...seen.values()].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
}

export function tryAddTagFromInput(
  raw: string,
  existing: string[],
): { tags: string[]; error?: string } {
  const t = raw.replace(/,/g, ' ').trim()
  if (!t) return { tags: existing }
  if (t.length > MAX_TEMPLATE_TAG_LENGTH) {
    return {
      tags: existing,
      error: `Each tag must be at most ${MAX_TEMPLATE_TAG_LENGTH} characters.`,
    }
  }
  if (existing.some(x => x.toLowerCase() === t.toLowerCase())) {
    return { tags: existing }
  }
  return { tags: [...existing, t] }
}
